export const apiGroups = [
  {
    category: 'Claims',
    apis: [
      'Documents',
      'Reconciliation and Appeal with attachments',
      'Claim Status and Payment',
      'Claims submission',
      'Claims Status (276/277) Extended X12',
    ],
    link: '/#/documentation/claims',
  },
  {
    category: 'Eligibility',
    apis: [
      'Eligibility',
      //  'Eligibility Lightweight',
      //'Eligibility and Benefits (270/271) Extended X12',
    ],
    link: '/#/documentation/eligibility',
  },
  {
    category: 'Eligibility Lightweight',
    apis: ['Eligibility Lightweight'],
    link: '/#/documentation/eligibilitylw',
  },
  {
    category: 'Eligibility and Benefits (270/271) Extended X12',
    apis: ['Eligibility and Benefits (270/271) Extended X12'],
    link: 'https://www.uhcprovider.com/content/dam/provider/docs/public/resources/api/API-Extended-X12-Eligibility-Benefits-Implementation-Guide.pdf',
  },

  {
    category: 'PriorAuth',
    apis: ['Prior Authorizations API'],
    link: '/#/documentation/priorauth',
  },
  {
    category: 'Referrals',
    apis: ['Referral Status', 'Referral Submission'],
    link: '/#/documentation/referrals',
  },
  {
    category: 'Dental',
    apis: ['Dental API'],
    link: '/#/documentation/dental',
  },
  {
    category: 'Provider Demographic',
    apis: ['Demographic update (Add/Term/Change)'],
    link: '/#/documentation/demographic',
  },
  {
    category: 'TrackIt',
    apis: ['TrackIt API'],
    link: '/#/documentation/trackit',
  },
  {
    category: 'Super Connector',
    apis: [
      'Member Eligibility Check',
      'Claims Precheck Inquiry',
      'Claims Actions',
    ],
    link: '/#/documentation/superconnector',
  },
];
